
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Bird } from "lucide-react";

export const WildlifeGuidelines = () => {
  return (
    <RegulationItem 
      value="wildlife-environment" 
      icon={Bird}
      iconColor="text-green-600"
      title="Wildlife & Environment Guidelines"
    >
      <ul className="space-y-2 text-tribal-neutral list-disc pl-5">
        <li>Enjoy bird watching around the lakes. Stay on main roads.</li>
        <li>Respect tribal sovereignty and land.</li>
      </ul>
    </RegulationItem>
  );
};
